module.exports = __webpack_public_path__ + "img/Character_Boy1.a0160870.png";